import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'; // Import Router
import { ThemeProvider, createTheme } from '@mui/material/styles'; // Import MUI theme components
import CssBaseline from '@mui/material/CssBaseline'; // Import CssBaseline for normalization
// Removed import './index.css'; as the file was deleted
import App from './App';
import reportWebVitals from './reportWebVitals';

// Create a default MUI theme instance
const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}> {/* Apply the theme */}
      <CssBaseline /> {/* Normalize styles */}
      <Router> {/* Wrap App with Router */}
        <App />
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
